import * as PlansActionTypes from 'actiontypes/plans';
import * as StoryletActionCreator from 'actions/storylet';
import PlansService from 'services/PlansService';
import { IPlansService } from 'types/plans';

/** ----------------------------------------------------------------------------
 * DELETE PLAN
 -----------------------------------------------------------------------------*/

export default deletePlan(new PlansService());

export function deletePlan(service: IPlansService) {
  return (branchId: number) => async (dispatch: Function) => {
    dispatch(deletePlanRequest());
    try {
      // const { data } = await service.deletePlan(branchId);
      await service.deletePlan(branchId);
      dispatch(deletePlanSuccess(branchId));
      // TODO: hmmmmmm......
      dispatch(StoryletActionCreator.clearCache());
    } catch (error) {
      console.error(error);
      dispatch(deletePlanFailure());
    }
  };
}

export const deletePlanRequest = () => ({
  type: PlansActionTypes.DELETE_PLAN_REQUESTED,
  isFetching: true,
});

export const deletePlanSuccess = (branchId: number) => ({
  type: PlansActionTypes.DELETE_PLAN_SUCCESS,
  isFetching: false,
  payload: {
    toDelete: branchId,
  },
});

export const deletePlanFailure = () => ({
  type: PlansActionTypes.DELETE_PLAN_FAILURE,
  isFetching: false,
});
